// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mMpnsa7wTSAwrAphZNfy{all:unset;box-sizing:border-box;padding:4px 16px 4px 10px;background-color:rgba(0,0,0,.8);backdrop-filter:blur(2px);border-radius:4px;display:inline-flex;align-items:center;gap:8px;cursor:pointer}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollToBottomButton": `mMpnsa7wTSAwrAphZNfy`
};
export default ___CSS_LOADER_EXPORT___;
